import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Grid, Col, Row} from 'react-bootstrap'
import { connect } from 'react-redux';
import _ from 'lodash'
import SelectAsync from 'react-select/lib/Async';
import LoadingIcon from '../../../../../components/LoadingIcon'

class CongressesReports extends Component {
    static contextTypes = {api: PropTypes.object};
    loadingIdCongresses = 'loadingCongresses';
    loadingIdEvents = 'loadingEvents';
    loadingIdCongressAttendancesByCongress = 'loadingCongressAttendancesByCongress';
    loadingIdEventAttendancesByEvent = 'loadingEventAttendancesByEvent';
    loadingIdEmittedCertificatesByCongress= 'loadingIdEmittedCertificatesByCongress';

    constructor(props,context){
        super(props);
        context.api.congresses.get(0,200,this.loadingIdCongresses);
        context.api.events.get(0,200,this.loadingIdEvents);
        context.api.congressAttendances.get(0,200,this.loadingIdCongressAttendancesByCongress);
        context.api.eventAttendances.get(0,200,this.loadingIdEventAttendancesByEvent);
        context.api.emittedCertificates.get(0,200, this.loadingIdEmittedCertificatesByCongress, {'certificate.event[exists]': true});
        context.api.emittedCertificates.get(0,200, this.loadingIdEmittedCertificatesByCongress, {'certificate.congress[exists]': true}, 'congressCertificates');


        this.state = {
            congress:{value:0,label:'Todos'},
            event:{value:0,label:'Todos'},
            congressCertificate:{value:0,label:'Todos'},
            eventCertificate:{value:0,label:'Todos'}
        };

        this.loadFilteredCongresses = _.debounce(this.loadFilteredCongresses, 250);
        this.loadFilteredCongresses();

        this.loadCongressesAttendances = _.debounce(this.loadCongressesAttendances,250);
        this.loadCongressesAttendances();

        this.loadFilteredEvents = _.debounce(this.loadFilteredEvents,250);
        this.loadFilteredEvents();
    }

    loadFilteredCongresses = ( name )=>{ return this.context.api.congresses.get( 0, 10, undefined, name?{name:name}:null,'filteredCongresses').then( (filteredCongresses=[])=> filteredCongresses.map( (filteredCongress)=>({value:filteredCongress.id, label: filteredCongress.name }) ) )};

    loadCongressesAttendances = (congress) =>{ return this.context.api.congressAttendances.get(0,200,this.loadingIdCongressAttendancesByCongress,congress?{'congress.name':congress}:null)};

    loadFilteredEvents = ( name )=>{ return this.context.api.events.get( 0, 10, undefined, name?{name:name}:null,'filteredEvents').then( (filteredEvents=[])=> filteredEvents.map( (filteredEvent)=>({value:filteredEvent.id, label: filteredEvent.name }) ) )};

    loadEventAttendances = (event) =>{ return this.context.api.eventAttendances.get(0,200,this.loadingIdEventAttendancesByEvent,event?{'event.name':event}:null)};

    loadEmittedCertificatesByCongress = (congress) =>{ return this.context.api.emittedCertificates.get(0,200,this.loadingIdEmittedCertificatesByCongress,congress?{'certificate.congress.name':congress}:null, 'congressCertificates')};

    loadEmittedCertificatesByEvent = (event) =>{ return this.context.api.emittedCertificates.get(0,200,this.loadingIdEmittedCertificatesByCongress,event?{'certificate.event.name':event}:null, 'eventCertificates')};

    getFormValue = ( name )=>{ return this.state[name]? this.state[name]:'';};

    onFormChange = ({target})=> this.setState(  { ...this.state, [target.name]:target.value},
        ()=>{
            if(target.name==='congress') this.loadCongressesAttendances(target.value.label);
           if(target.name==='event') this.loadEventAttendances(target.value.label);
           if(target.name === 'congressCertificate') this.loadEmittedCertificatesByCongress(target.value.label);
            if(target.name === 'eventCertificate') this.loadEmittedCertificatesByEvent(target.value.label);
        });

    render(){
        return(
            <div className="container-fluid CongressesReports">
                <Grid fluid>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Congresos</h4>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.loadingIds&&this.props.loadingIds[this.loadingIdCongresses]?<LoadingIcon/>:this.props.congressesMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.congresses.exportUrl({}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.congresses.exportUrl({}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Eventos</h4>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.loadingIds&&this.props.loadingIds[this.loadingIdEvents]?<LoadingIcon/>:this.props.eventsMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.events.exportUrl({}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.events.exportUrl({}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Asistencias a congresos</h4>
                                <div style={{textAlign:'center',paddingTop:'10px',margin:'10px auto',width:'70%'}}>
                                    <SelectAsync
                                        cacheOptions
                                        defaultOptions={this.props.filteredCongresses.map((congress)=>({value:congress,label:congress.name,id:congress.id}))}
                                        placeholder='Seleccione un congreso'
                                        noOptionsMessage={()=>"Sin coincidencias"}
                                        loadOptions={this.loadFilteredCongresses}
                                        value={this.getFormValue('congress')||'Todos'}
                                        onChange={(value)=>this.onFormChange({target:{name:"congress", value}})}/>
                                </div>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.loadingIds&&this.props.loadingIds[this.loadingIdCongressAttendancesByCongress]?<LoadingIcon/>:this.props.congressAttendancesMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.congressAttendances.exportUrl(this.state.congress && this.state.congress.id?{congress:this.state.congress.id}:{}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.congressAttendances.exportUrl(this.state.congress && this.state.congress.id?{congress:this.state.congress.id}:{}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>

                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Asistencias a eventos</h4>
                                <div style={{textAlign:'center',paddingTop:'10px',margin:'10px auto',width:'70%'}}>
                                    <SelectAsync
                                        cacheOptions
                                        defaultOptions={this.props.filteredEvents.map((event)=>({value:event,label:event.name,id:event.id}))}
                                        placeholder='Seleccione un evento'
                                        noOptionsMessage={()=>"Sin coincidencias"}
                                        loadOptions={this.loadFilteredEvents}
                                        value={this.getFormValue('event')||'Todos'}
                                        onChange={(value)=>this.onFormChange({target:{name:"event", value}})}/>
                                </div>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.loadingIds&&this.props.loadingIds[this.loadingIdEventAttendancesByEvent]?<LoadingIcon/>:this.props.eventAttendancesMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.eventAttendances.exportUrl(this.state.event && this.state.event.id?{event: this.state.event.id}:{}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.eventAttendances.exportUrl(this.state.event && this.state.event.id?{event: this.state.event.id}:{}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Constancias de congresos</h4>
                                <div style={{textAlign:'center',paddingTop:'10px',margin:'10px auto',width:'70%'}}>
                                    <SelectAsync
                                        cacheOptions
                                        defaultOptions={this.props.filteredCongresses.map((congress)=>({value:congress,label:congress.name,id:congress.id}))}
                                        placeholder='Seleccione un congreso'
                                        noOptionsMessage={()=>"Sin coincidencias"}
                                        loadOptions={this.loadCongresses}
                                        value={this.getFormValue('congressCertificate')||'Todos'}
                                        onChange={(value)=>this.onFormChange({target:{name:"congressCertificate", value}})}/>
                                </div>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.congressCertificatesMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.emittedCertificates.exportUrl(this.state.congressCertificate && this.state.congressCertificate.id?{'certificate.congress': this.state.congressCertificate.id}:{}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.emittedCertificates.exportUrl(this.state.congressCertificate && this.state.congressCertificate.id?{'certificate.congress': this.state.congressCertificate.id}:{}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <div className='reportCard'>
                                <h4>Constancias de eventos</h4>
                                <div style={{textAlign:'center',paddingTop:'10px',margin:'10px auto',width:'70%'}}>
                                    <SelectAsync
                                        cacheOptions
                                        defaultOptions={this.props.filteredEvents.map((congress)=>({value:congress,label:congress.name,id:congress.id}))}
                                        placeholder='Seleccione un evento'
                                        noOptionsMessage={()=>"Sin coincidencias"}
                                        loadOptions={this.loadCongresses}
                                        value={this.getFormValue('eventCertificate')||'Todos'}
                                        onChange={(value)=>this.onFormChange({target:{name:"eventCertificate", value}})}/>
                                </div>
                                <div className='stat-number'><div className='title'>Total</div>{this.props.emittedCertificatesMeta.totalItems}</div>
                                <p className='downloadLink'><a href={this.context.api.emittedCertificates.exportUrl(this.state.eventCertificate && this.state.eventCertificate.id?{'certificate.event': this.state.eventCertificate.id}:{}, 'xlsx')}>Descargar excel</a></p>
                                <p className='downloadLink'><a href={this.context.api.emittedCertificates.exportUrl(this.state.eventCertificate && this.state.eventCertificate.id?{'certificate.event': this.state.eventCertificate.id}:{}, 'pdf')}>Descargar PDF</a></p>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = ( { api: { congresses=[], congressesMeta={},events=[],eventsMeta={},eventAttendances=[],eventAttendancesMeta={},congressAttendances=[],congressAttendancesMeta={},emittedCertificates=[],emittedCertificatesMeta={},filteredCongresses=[],filteredCongressesMeta={},filteredEvents=[],filteredEventsMeta={}, congressCertificates=[], congressCertificatesMeta={}  } ,loadingIds} )=>{
    return {congresses, congressesMeta,events,eventsMeta, eventAttendances, eventAttendancesMeta,congressAttendances,congressAttendancesMeta,emittedCertificates,emittedCertificatesMeta,filteredCongresses,filteredCongressesMeta,filteredEvents,filteredEventsMeta, congressCertificates, congressCertificatesMeta,loadingIds}
};

export default connect(mapStateToProps)(CongressesReports);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Reports/CongressesReports/index.jsx